import axios from './axios';

const API_URL = '/C4-Nicaragua/Factura'; // ajusta si usas otro endpoint"el nombre del archivo de route de backend 

export const getFacturas = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener  facturas:', error);
    return [];
  }
};

export const addFactura = async (factura) => {
  try {
    // console.log(factura);
    // console.log('llego api')
    const response = await axios.post(API_URL, factura);
    // console.log(response);
    return response.data;
  } catch (error) {
    // console.log(error);
    console.error('Error al guardar factura', error);
    throw error;
  }
};

export const updateFactura = async (id, factura) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, factura);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar factura', error);
    throw error;
  }
};

export const eliminarFactura  = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar Factura', error);
    throw error;
  }
};

export const  getFacturasPorCliente= async(ruc)  =>
{
    try{
     // console.log(API_URL);
      //console.log(ruc);
    const response = await axios.get(`${API_URL}/${ruc}`);

    return response.data;    
    }
    catch(error)
    {
      console.error('Error al obtener facturas por cliente', error);
      throw error;
    }
}
